import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementScheduleService } from '@core/services/entities/management-schedule.service';
import { CreateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/create-management-schedule.request.dto';
import { ListManagementScheduleRequestDto } from '@domain/management-schedule/dtos/list-management-schedule.request.dto';
import { ManagementScheduleResponseDto } from '@domain/management-schedule/dtos/management-schedule.response.dto';
import { UpdateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/update-management-schedule.request.dto';
import { UpdateStateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/update-state-management-schedule.request.dto';
import { ManagementScheduleRepository } from '@domain/management-schedule/repositories/management-schedule.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementScheduleRepositoryService implements ManagementScheduleRepository {
  constructor(private managementScheduleService: ManagementScheduleService) {}

  list(
    request: ListManagementScheduleRequestDto,
  ): Observable<ApiResponse<PageableResponse<ManagementScheduleResponseDto>>> {
    return this.managementScheduleService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<ManagementScheduleResponseDto>> {
    return this.managementScheduleService.show(request);
  }

  create(
    request: CreateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>> {
    return this.managementScheduleService.create(request);
  }

  update(
    request: UpdateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>> {
    return this.managementScheduleService.update(request);
  }

  updateState(
    request: UpdateStateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>> {
    return this.managementScheduleService.updateState(request);
  }

  delete(request: RefId): Observable<ApiResponse<void>> {
    return this.managementScheduleService.delete(request);
  }
}
